{
  "logoAlt": "Smart Word Labs",
  "footer": {
    "copyright": "© {{year}} Smart Word Labs · {{tagline}}"
  },
  "breadcrumb": {
    "home": "Inicio",
    "ariaLabel": "Ruta de navegación"
  },
  "notifications": {
    "ariaLabel": "Notificaciones",
    "unreadMore": "9+",
    "title": "Alertas",
    "markRead": "Marcar como leídas",
    "new": "nueva",
    "empty": "Aún no hay alertas.",
    "error": "No se pudieron actualizar las notificaciones"
  },
  "mobileCta": {
    "bookFreeAssessment": "Reservar evaluación gratuita"
  }
}
